import colors from "./colors";


export interface ThemeProps {
    background: string;
    backgroundLighter: string;
    backgroundDarker: string;
    fontFamily1: string;  
    fontFamily2: string;   
  }
  
  export const ruukkiTheme: ThemeProps = {
    background: colors.backgroundRuukki,
    backgroundLighter: colors.backgroundLighterRuukki,
    backgroundDarker: colors.backgroundDarkerRuukki,
    fontFamily1: "Roboto Condensed",
    fontFamily2: "Roboto"
  };
  
  export const plannjaTheme: ThemeProps = {
    background: colors.backgroundPlannja,
    backgroundLighter: colors.backgroundLighterPlannja,
    backgroundDarker: colors.backgroundDarkerPlannja,  
    fontFamily1: "MaisonNeue",
    fontFamily2: "MaisonNeue"
  };

  export const piristeelTheme: ThemeProps = {
    background: colors.backgroundPiristeel,
    backgroundLighter: colors.backgroundlighterPiristeel,
    backgroundDarker: colors.backgroundDarkerPiristeel,
    fontFamily1: "Khand",
    fontFamily2: "OpenSans"
  };
  